import { UI } from 'Icon/ui'
import * as React from 'react'
import { connect } from 'react-redux'
import { AppState } from '../../data/state'
import { Slink } from '../../routing/links'

interface LoginProps {
  memberToken: string | undefined
  avatarUrl: string
}

const LoginComponent: React.FC<LoginProps> = props => {
  const loggedIn =
    props.memberToken &&
    props.memberToken.length > 0 &&
    props.memberToken.trim().length > 0

  return (
    <React.Fragment>
      {!loggedIn ? (
        <Slink name="login">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 473">
            {UI.avatar}
          </svg>
        </Slink>
      ) : (
        <Slink name="member">
          {/* TODO: implement avatarUrl */}
          {props.avatarUrl !== '' ? (
            <img src={props.avatarUrl} alt="" className="avatar" />
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 473">
              {UI.avatar}
            </svg>
          )}
        </Slink>
      )}
    </React.Fragment>
  )
}

const mapStateToProps = (state: AppState) => ({
  memberToken: state.member.token,
  avatarUrl: state.member.image,
})

export default connect(mapStateToProps)(LoginComponent)
